import axios from "axios";
import { BASE_URL } from "../Host";

export const getWatchVideo = async (token) => {
	try {
		const res = await axios.get(
			`${BASE_URL}payment/watch/${token}`,
			{
				headers: {
					"Content-Type": "application/json",
				},
			},
		);

		return res;
	} catch (error) {
		console.error("Error fetching watch video:", error);
		throw error;
	}
};

export const downloadVideo = async () => {
	const res = await axios.get(
		`${BASE_URL}video/download/1151664870`
	);

	const downloadUrl = res?.data?.data;

	if (downloadUrl) {
		window.location.href = downloadUrl; // ✅ triggers browser download
	}
};

